module.exports = __webpack_public_path__ + "static/media/280078.edd71c82.png";